import * as React from 'react';
const LiveAgentIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.019 2a8.03 8.03 0 0 0-6.873 3.88.127.127 0 0 1-.237-.066V3.21a.454.454 0 0 0-.909 0v3.324a.906.906 0 0 0 .909.907h3.328a.454.454 0 1 0 0-.908H4.038a.127.127 0 0 1-.109-.193 7.11 7.11 0 0 1 6.09-3.432 7.107 7.107 0 0 1 7.074 6.39.454.454 0 0 0 .905-.089A8.016 8.016 0 0 0 10.018 2m-7.61 8.313a.454.454 0 0 0-.407.497 8.016 8.016 0 0 0 7.407 7.189.424.424 0 0 0 .446-.434.494.494 0 0 0-.465-.478 7.11 7.11 0 0 1-6.483-6.367.454.454 0 0 0-.497-.407M18.5 13.55a2.1 2.1 0 0 0-.614-1.432 2.094 2.094 0 0 0-2.884-.08 2.094 2.094 0 0 0-2.885.079 2.114 2.114 0 0 0-.083 2.897l2.754 2.772a.3.3 0 0 0 .426 0l2.755-2.772c.356-.402.547-.926.531-1.464m-6.297.01a1.4 1.4 0 0 1 .409-.944 1.397 1.397 0 0 1 1.864-.104l.029.024-.742.747a.35.35 0 0 0 .497.495l1.222-1.228a1.396 1.396 0 0 1 1.908.066 1.41 1.41 0 0 1 .068 1.917l-2.244 2.258a.3.3 0 0 1-.426 0l-2.243-2.259a1.4 1.4 0 0 1-.342-.971"
      fill="currentColor"
    />
  </svg>
);
export default LiveAgentIcon;
